export const emailContentQueryKeys = {
  _base: () => ["emailContent"],
  all: () => [...emailContentQueryKeys._base()],
  single: (emailContentId: string) => [
    ...emailContentQueryKeys._base(),
    emailContentId,
  ],
  byAgencyId: (agencyId: string) => [
    ...emailContentQueryKeys._base(),
    "byAgency",
    agencyId,
  ],
  byTemplateId: (agencyId: string, emailTemplateId: string) => [
    ...emailContentQueryKeys.byAgencyId(agencyId),
    "byTemplateId",
    emailTemplateId,
  ],
};
